export default __webpack_public_path__ + "d5113c396fe18d59f1b4af3f170c3efa.svg";